/** @format */

import { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { setSideBarToggle } from "../ReduxToolkit/Reducers/Layout/LayoutReducer";
import { addSidebarTypes } from "../ReduxToolkit/Reducers/Layout/ThemeCustomizerReducer";
import { AppDispatch, RootState } from "../ReduxToolkit/Store";
import Header from "./Header";
import Loader from "./Loader";
import Taptop from "./Taptop";
import {
  fetchProducts,
  fetchCategories,
} from "../ReduxToolkit/Reducers/ProductsReducer";
import { getVendorID } from "../services/helper";
import BackgroundOrdersSync from "./BackgroundOrdersSync";
import {
  fetchCustomers,
  fetchPaymentTypes,
} from "../ReduxToolkit/Reducers/AppReducer";
import { fetchRegisters } from "../ReduxToolkit/Reducers/CartReducer";
import { useRegisterManager } from "../hooks/useRegisterManager";
import { BsChatDotsFill } from "react-icons/bs"; // Chat Icon
import { Modal, ModalBody, ModalHeader } from "reactstrap"; // Reactstrap Modal
import PrivateChatContainer from "../Components/Applications/Chat/PrivateChat";
import "./chat.css";
import FloatingChatBubble from "./ChatBubble";
import WebSocketManager from "../Components/Applications/Chat/PrivateChat/SocketManager";
import ServiceWorker from "./ServiceWorker";
import NotificationHandler from "./NoficiationPermissions";
import ViewManager from "./ViewManager";

export default function Layout() {
  const { sidebar_types } = useSelector(
    (state: RootState) => state.themeCustomizer,
  );
  const { sideBarToggle } = useSelector((state: RootState) => state.layout);
  const dispatch = useDispatch<AppDispatch>();
  const vendor_id = getVendorID();
  const location = useLocation();

  const [isChatOpen, setIsChatOpen] = useState(false); // ✅ Chat Modal State

  const updateSidebarBasedOnWidth = useCallback(() => {
    const windowWidth = window.innerWidth;
    const isIframe = window.self !== window.top;

    if (isIframe) {
      dispatch(addSidebarTypes("horizontal-wrapper"));
      if (windowWidth <= 992) {
        dispatch(setSideBarToggle(true));
      } else {
        dispatch(setSideBarToggle(false));
      }
      return;
    }

    if (sidebar_types === "compact-wrapper") {
      if (windowWidth <= 1200) {
        dispatch(setSideBarToggle(true));
      } else {
        dispatch(setSideBarToggle(false));
      }
    } else if (sidebar_types === "horizontal-wrapper") {
      if (windowWidth <= 992) {
        dispatch(setSideBarToggle(true));
        dispatch(addSidebarTypes("compact-wrapper"));
      } else {
        dispatch(setSideBarToggle(false));
        dispatch(addSidebarTypes("horizontal-wrapper"));
      }
    }
  }, [sidebar_types, dispatch, location.pathname]);

  useEffect(() => {
    updateSidebarBasedOnWidth();
    const handleResize = () => {
      updateSidebarBasedOnWidth();
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [updateSidebarBasedOnWidth]);

  useEffect(() => {
    vendor_id && dispatch(fetchProducts());
    vendor_id && dispatch(fetchCategories());
    vendor_id && dispatch(fetchCustomers());
    dispatch(fetchPaymentTypes());
    dispatch(fetchRegisters());
  }, [dispatch]);

  // check register if open, if not then create
  useRegisterManager();

  return (
    <>
      <ServiceWorker />
      <NotificationHandler />
      <WebSocketManager />

      {1 && <BackgroundOrdersSync />}
      <Loader />
      <Taptop />
      <div
        className={`page-wrapper ${
          sideBarToggle ? "compact-wrapper" : sidebar_types
        }`}
        id="pageWrapper"
      >
        <Header />
        <div className="page-body-wrapper" id="pageBodyWrapper">
          <Outlet />
          {/* <FooterLayout /> */}
        </div>
      </div>

      {/* ✅ Floating Chat Bubble */}
      <FloatingChatBubble onIsChatOpen={setIsChatOpen} location={location} />

      <ViewManager />

      {/* ✅ Full-Screen Chat Modal */}
      <Modal
        isOpen={isChatOpen}
        toggle={() => setIsChatOpen(false)}
        className="modal-fullscreen"
        backdrop="static"
      >
        {/* <ModalHeader
          toggle={() => setIsChatOpen(false)}
          className="chat-modal-header"
        >
          Private Chat
        </ModalHeader> */}
        <ModalBody className="chat-modal-body">
          <PrivateChatContainer />
        </ModalBody>
      </Modal>
    </>
  );
}
